import styled from 'styled-components';
import { Button, Select } from '@/ui';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 1rem;
  display: flex;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    min-height: 3rem;
    width: 100%;
    margin-bottom: 1rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
  margin-bottom: 1rem;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledSelect = styled(Select)`
  &&& {
    height: auto;
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;

export const StyledPotentialPartnersWrapper = styled.div`
  display: flex;
  padding: 2rem;
  flex-direction: column;
`;
